"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePromotion = void 0;
const typings_1 = require("../typings");
const utils_1 = require("../utils");
class BasePromotion {
    constructor(props) {
        this.props = props;
        this.selectedProductIds = [];
        this.selectedProductIds = props.selectedProducts.map((selectedProduct) => selectedProduct.id);
    }
    /**
     * Get bundle setting
     */
    get bundleSetting() {
        return this.props.settings.isBundled;
    }
    /**
     * Get chosen shipping method
     * @deprecated
     * Use chosenShippingIds
     */
    get chosenShippingMethod() {
        return this.props.settings.shippingMethod;
    }
    /**
     * Get chosen shipping ids that qualify for promotion
     */
    get chosenShippingIds() {
        return (this.props.settings.shippingIds || []);
    }
    /**
     * Get criteria
     */
    get criteria() {
        const promotionSettings = this.getPromotionSettings();
        if ((promotionSettings === null || promotionSettings === void 0 ? void 0 : promotionSettings.criteria) && (promotionSettings === null || promotionSettings === void 0 ? void 0 : promotionSettings.criteria.length)) {
            return promotionSettings === null || promotionSettings === void 0 ? void 0 : promotionSettings.criteria;
        }
        const { condition, discount, threshold } = promotionSettings;
        const freeProducts = this.getPromotionFreeProducts();
        if (condition === typings_1.PromotionCondition.BUY_ANY_PRODUCT) {
            return [
                {
                    discount,
                    freeProducts,
                    thresholds: [],
                },
            ];
        }
        return [
            {
                discount,
                freeProducts,
                operator: typings_1.PromotionOperator.AT_LEAST,
                thresholds: [threshold].filter(Boolean),
            },
        ];
    }
    /**
     * Get award from low to high flag
     */
    get isAwardFromLowToHigh() {
        return this.props.settings.awardLowToHigh;
    }
    /**
     * Is auto generated criteria
     */
    get isAutoGeneratedCriteria() {
        if (!this.props.settings.criteria) {
            return true;
        }
        return false;
    }
    /**
     * Get is repeatable flag, returning "true" if value is
     * either "undefined" or "null"
     *
     *
     * Getter function will check whether its value is undefined or null or not
     * before returning default value here. Why variable has different is because
     * if calculator is being in other backend system and "isRepeatable" has not been
     * set. It will return "undefined" whereas if it is being used in GQL. It will
     * resort to "null" by default
     * Possible value
     * - undefined -> via Database
     * - null -> via GQL tho Database returns as "undefined"
     * @returns {boolean}
     */
    get isRepeatable() {
        // Only two possible promotion that supports "isRepeatable" flag at the moment
        const { isRepeatable } = this.props.settings;
        /**
         * Using Nullish coalescing here to check against falsy value but we cannot use '||'
         * because that would not work with falsy value where value is "undefined" or "null"
         * reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Nullish_coalescing_operator
         */
        return isRepeatable !== null && isRepeatable !== void 0 ? isRepeatable : true;
    }
    /**
     * Get selected products from promotion
     */
    get selectedProducts() {
        return this.props.selectedProducts;
    }
    /**
     * Get promotion's condition
     */
    get settingCondition() {
        return this.props.settings.condition;
    }
    // #region Threshold
    /**
     * Get amount threshold
     */
    get amountThreshold() {
        return this.props.settings.threshold.amount;
    }
    /**
     * Get price threshold
     */
    get priceThreshold() {
        return this.props.settings.threshold.price;
    }
    // #endregion
    // #region private functions
    /**
     * Add applied promotion to every product skus
     * @param productSKUs
     * @param additionalProperties
     */
    addAppliedPromotionToEveryProductSKUs(productSKUs, additionalProperties) {
        return productSKUs.map((productSKU) => (Object.assign(Object.assign({}, productSKU), { promotions: this.addAppliedPromotion(productSKU.promotions, additionalProperties) })));
    }
    /**
     * Add applied promotion to selected product skus
     * @param productSKUs
     * @param additionalProperties
     */
    addAppliedPromotionToSelectedProductSKUs(productSKUs, additionalProperties) {
        const hasAppliedProductSKUIds = Boolean(additionalProperties &&
            additionalProperties.appliedProductSKUIds &&
            additionalProperties.appliedProductSKUIds.length);
        return productSKUs.map((productSKU) => {
            var _a;
            if (this.selectedProductIds.includes(productSKU.id)) {
                let newAdditionalProperties = additionalProperties;
                if (hasAppliedProductSKUIds && !((_a = additionalProperties === null || additionalProperties === void 0 ? void 0 : additionalProperties.appliedProductSKUIds) === null || _a === void 0 ? void 0 : _a.includes(productSKU.id))) {
                    newAdditionalProperties = undefined;
                }
                return Object.assign(Object.assign({}, productSKU), { promotions: this.addAppliedPromotion(productSKU.promotions, newAdditionalProperties) });
            }
            return productSKU;
        });
    }
    // #endregion
    /**
     * Add applied promotion to promotions
     * @param promotions
     * @param additionalProperties
     */
    addAppliedPromotion(promotions = [], additionalProperties = {}) {
        const promotion = Object.assign(Object.assign({ totalDiscount: 0, remarks: [] }, this.props), additionalProperties);
        return promotions.concat([promotion]);
    }
    /**
     * Add applied promotion to product skus
     * @param productSKUs
     * @param additionalProperties
     */
    addAppliedPromotionToProductSKUs(productSKUs, additionalProperties) {
        if (!this.selectedProductIds.length) {
            return this.addAppliedPromotionToEveryProductSKUs(productSKUs, additionalProperties);
        }
        return this.addAppliedPromotionToSelectedProductSKUs(productSKUs, additionalProperties);
    }
    /**
     * Compose new cart with applied promotion
     * @param cart
     * @param additionalProperties
     * @returns {Cart}
     */
    composeNewCartWithAppliedPromotion(cart, additionalProperties) {
        const { remarks = [], totalDiscount = 0 } = additionalProperties;
        // Product promotion
        if (this.props.type === typings_1.PromotionType.PRODUCT) {
            return Object.assign(Object.assign({}, cart), { promotions: totalDiscount > 0 || remarks.length
                    ? cart.promotions.concat([
                        Object.assign(Object.assign({}, this.props), { remarks,
                            totalDiscount, selectedProducts: (0, utils_1.getSelectedProductsWithSelectedProductIdsAndPromotionIds)(cart.productSKUs, this.selectedProductIds, [this.props.id]) }),
                    ])
                    : cart.promotions, totalPrice: cart.totalPrice - totalDiscount > 0 ? cart.totalPrice - totalDiscount : 0, totalProductDiscount: cart.totalProductDiscount + totalDiscount });
        }
        // Shipping promotion
        return Object.assign(Object.assign({}, cart), { promotions: cart.promotions.concat([
                Object.assign(Object.assign({}, this.props), { remarks,
                    totalDiscount, selectedProducts: (0, utils_1.getSelectedProductsWithSelectedProductIdsAndPromotionIds)(cart.productSKUs, this.selectedProductIds, [this.props.id]) }),
            ]), 
            // Check whether total discount does not equal to shipping price
            totalShippingDiscount: cart.shippingPrice !== totalDiscount ? cart.totalShippingDiscount + totalDiscount : totalDiscount });
    }
    /**
     * Get matched criteria by target
     * @param target
     * @returns {PromotionCriteria | undefined}
     */
    getCriteriaByTarget(target) {
        const sortedCriteria = this.getPromotionCriteria();
        return sortedCriteria.find((criteria) => (0, utils_1.isMetThresholdCriteria)(criteria, target));
    }
    /**
     * Get discount from matched criteria by target
     * @param target
     * @returns {number | undefined}
     */
    getDiscountByTarget(target) {
        const matchedCriteria = this.getCriteriaByTarget(target);
        if (!matchedCriteria) {
            return undefined;
        }
        return (0, utils_1.getPromotionDiscountCriteria)(matchedCriteria);
    }
    /**
     * Get next criteria by target
     * @param target
     * @returns {PromotionCriteria | undefined}
     */
    getNextPromotionCriteriaByTarget(target) {
        const sortedCriteria = this.getPromotionCriteria();
        return sortedCriteria.find((criteria) => {
            const matchedCriteria = (0, utils_1.isMetThresholdCriteria)(criteria, target);
            if (matchedCriteria) {
                return false;
            }
            if (!criteria.maximumThreshold) {
                return false;
            }
            const targetIsMoreThanMaximumThreshold = target >= criteria.maximumThreshold;
            return !targetIsMoreThanMaximumThreshold;
        });
    }
    /**
     * Get promotion criteria
     * @returns {ReadonlyArray<PromotionCriteria>}
     */
    getPromotionCriteria() {
        return (0, utils_1.sortedPromotionCriteria)(this.criteria);
    }
    /**
     * Get promotion discount
     * @returns {number | undefined}
     */
    getPromotionDiscount() {
        if (this.settingCondition !== typings_1.PromotionCondition.BUY_ANY_PRODUCT) {
            return undefined;
        }
        return (0, utils_1.getPromotionDiscountCriteria)(this.criteria[0]);
    }
    /**
     * Get promotion type
     * @returns {PromotionType}
     */
    getPromotionType() {
        return this.props.type;
    }
    /**
     * Get promotion priority
     * @returns {number}
     */
    getPromotionPriority() {
        return this.props.priority || 0;
    }
    /**
     * Get promotion's setting type
     * @returns {PromotionSettingsType}
     */
    getPromotionSettingsType() {
        return this.props.settings.type;
    }
    /**
     * Get promotion id
     * @returns {ID}
     */
    getPromotionId() {
        return this.props.id;
    }
    /**
     * Get promotion selected product (SKU) id
     * @returns {ReadonlyArray<ID>}
     */
    getPromotionSelectedProductSKUIds() {
        return this.props.selectedProducts.map((selectedProduct) => selectedProduct.id);
    }
    /**
     * Get promotion free products (SKU)
     * @returns {ReadonlyArray<FreeProduct>}
     */
    getPromotionFreeProducts() {
        return this.props.freeProducts || [];
    }
    /**
     * Get promotion setting threshold
     * @returns {PromotionThreshold}
     */
    getPromotionSettingThreshold() {
        return this.props.settings.threshold;
    }
    /**
     * Get promotion settings
     * @returns {PromotionSettings}
     */
    getPromotionSettings() {
        return this.props.settings;
    }
    /**
     * Get bundle setting
     * @returns {boolean}
     */
    getBundleSetting() {
        return this.props.settings.isBundled || false;
    }
    /**
     * Get promotion's total discount
     * @returns {PromotionSettings}
     */
    getPromotionTotalDiscount() {
        return this.props.totalDiscount;
    }
    /**
     * Has amount threshold in promotion criteria
     * @returns {boolean}
     */
    hasAmountThresholdInPromotionCriteria() {
        const promotionCriteria = this.criteria;
        return promotionCriteria.some((promoCriteria) => promoCriteria.thresholds.some((threshold) => (0, utils_1.isNotNullAndUndefined)(threshold.amount)));
    }
    /**
     * Has price threshold in promotion criteria
     * @returns {boolean}
     */
    hasPriceThresholdInPromotionCriteria() {
        const promotionCriteria = this.criteria;
        return promotionCriteria.some((promoCriteria) => promoCriteria.thresholds.some((threshold) => (0, utils_1.isNotNullAndUndefined)(threshold.price)));
    }
    /**
     * Is matched selected shipping method
     * @param cart
     * @returns {boolean}
     */
    isMatchedSelectedShippingMethod(cart) {
        /**
         * ** Note **
         * Handle case where chosen shipping ids are defined which means
         * promotion is already migrated to support new shipping service
         */
        if (this.chosenShippingIds.length) {
            return (0, utils_1.isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId)(cart, this.chosenShippingIds);
        }
        // Backward compatible
        return (0, utils_1.isMatchedSelectedShippingByChosenShippingMethod)(cart, this.chosenShippingMethod);
    }
    /**
     * Set promotion's up selling information by promotion criteria
     * @param criteria
     * @returns {this}
     */
    setPromotionUpSellingInformationByPromotionCriteria(criteria) {
        const discount = (0, utils_1.getPromotionDiscountCriteria)(criteria);
        const freeProducts = criteria.freeProducts || [];
        // eslint-disable-next-line functional/immutable-data
        this.upSellingDiscount = discount;
        // eslint-disable-next-line functional/immutable-data
        this.upSellingFreeProducts = [...freeProducts];
        if (criteria.minimumThreshold) {
            // eslint-disable-next-line functional/immutable-data
            this.upSellingThreshold = criteria.minimumThreshold;
        }
        return this;
    }
    /**
     * Set promotion's remaining amount
     * @returns {this}
     */
    setPromotionRemainingAmount(remainingAmount) {
        // eslint-disable-next-line functional/immutable-data
        this.remainingAmount = remainingAmount;
        return this;
    }
    /**
     * Set promotion's remaining price
     * @returns {this}
     */
    setPromotionRemainingPrice(remainingPrice) {
        // eslint-disable-next-line functional/immutable-data
        this.remainingPrice = remainingPrice;
        return this;
    }
    /**
     * Set promotion's remaining product sku id
     * @returns {this}
     */
    setPromotionRemainingProductSKUId(productSKUId) {
        // eslint-disable-next-line functional/immutable-data
        this.remainingProductSKUId = productSKUId;
        return this;
    }
    toBasePromotionJSON() {
        return Object.assign(Object.assign({}, this.props), { remainingAmount: this.remainingAmount, remainingPrice: this.remainingPrice, remainingProductSKUId: this.remainingProductSKUId, upSellingDiscount: this.upSellingDiscount, upSellingFreeProducts: this.upSellingFreeProducts, upSellingThreshold: this.upSellingThreshold });
    }
}
exports.BasePromotion = BasePromotion;
//# sourceMappingURL=base.js.map